import { render, staticRenderFns } from "./serveYou.vue?vue&type=template&id=3b115b61&scoped=true&"
import script from "./serveYou.vue?vue&type=script&lang=js&"
export * from "./serveYou.vue?vue&type=script&lang=js&"
import style0 from "./serveYou.vue?vue&type=style&index=0&id=3b115b61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b115b61",
  null
  
)

export default component.exports